(() => {
  if (window.__fpGamesSignupLoaded) return;
  window.__fpGamesSignupLoaded = true;
  const initialized = new WeakSet();
  const pending = new Set();
  const accepted = new Set();
  function initialize(root) {
    if (initialized.has(root)) return;
    initialized.add(root);
    const messages = root.dataset;
    const form = root.querySelector('[data-games-form]');
    const status = form.querySelector('[data-signup-status]');
    const fieldset = form.querySelector('fieldset');
    const button = form.querySelector('[type="submit"]');
    const unavailable = form.querySelector('[data-signup-unavailable]');
    const buttonMarkup = button.innerHTML;
    if (typeof fetch !== 'function' || typeof AbortController !== 'function') return;
    form.addEventListener('submit', async event => {
      event.preventDefault();
      if (!form.reportValidity() || form.elements.website.value) return;
      const email = form.elements.email.value.trim().toLowerCase();
      const key = messages.list + '|' + messages.source + '|' + email;
      if (pending.has(key)) return;
      if (accepted.has(key)) {status.textContent = messages.success; return;}
      pending.add(key);
      button.disabled = true;
      button.textContent = messages.sending;
      form.setAttribute('aria-busy', 'true');
      status.textContent = '';
      form.dataset.result = 'pending';
      const controller = new AbortController();
      const timeout = setTimeout(() => controller.abort(), 45000);
      const properties = {interest_games:'yes','Games Signup Source':messages.source,'Games Consent Version':'2026-10-09-v2','Games Email Consent':true};
      if (messages.interest === 'offtop') {
        properties.interest_offtop = 'yes';
        properties['OFFTOP Signup Source'] = 'OFFTOP landing page';
        properties['OFFTOP Consent Version'] = '2026-10-09-v2';
        properties['OFFTOP Email Consent'] = true;
      }
      if (messages.interest === 'misrated') {
        properties.interest_misrated = 'yes';
        properties['MISRATED Signup Source'] = 'MISRATED landing page';
        properties['MISRATED Consent Version'] = '2026-10-09-v2';
        properties['MISRATED Email Consent'] = true;
      }
      if (messages.interest === 'ants') {
        properties.interest_ants = 'yes';
        properties['Ants Signup Source'] = 'Ants & Crumbles retail landing page';
        properties['Ants Consent Version'] = '2026-10-12-v1';
        properties['Ants Email Consent'] = true;
      }
      const payload = {data:{type:'subscription',attributes:{custom_source:messages.source,profile:{data:{type:'profile',attributes:{email,subscriptions:{email:{marketing:{consent:'SUBSCRIBED'}}},properties}}}},relationships:{list:{data:{type:'list',id:messages.list}}}}};
      if (new URLSearchParams(location.search).get('offtop_qa') === '1') {
        payload.data.attributes.custom_source += ' QA';
        properties['Games QA Test'] = true;
        if (messages.interest === 'offtop') properties['OFFTOP QA Test'] = true;
        if (messages.interest === 'misrated') properties['MISRATED QA Test'] = true;
      }
      try {
        const response = await fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(messages.company), {method:'POST',headers:{'Content-Type':'application/vnd.api+json','Accept':'application/vnd.api+json',revision:'2026-07-15'},body:JSON.stringify(payload),signal:controller.signal});
        form.dataset.result = 'http-' + response.status;
        if (response.status !== 202) throw new Error('Signup not accepted');
        accepted.add(key);
        status.textContent = messages.success;
        form.reset();
      } catch (error) {
        if (form.dataset.result === 'pending') form.dataset.result = error.name === 'AbortError' ? 'timeout' : 'network-error';
        status.textContent = messages.failure;
      } finally {
        clearTimeout(timeout);
        pending.delete(key);
        button.disabled = false;
        button.innerHTML = buttonMarkup;
        form.removeAttribute('aria-busy');
      }
    });
    unavailable.hidden = true;
    fieldset.disabled = false;
  }
  const init = target => {if (target.matches?.('[data-games-signup]')) initialize(target);target.querySelectorAll('[data-games-signup]').forEach(initialize);};
  init(document);
  document.addEventListener('shopify:section:load', event => init(event.target));
})();


